import React from "react";
import { FaTimes } from "react-icons/fa";
import { toast } from "react-hot-toast";
import Uploader from "../../components/Uploader";
import { Button } from "../../components/Form";
import axios from "axios";
import { BaseUrl } from "../../BaseUrl";

function PatientImages({ patientId }) {
  const [image, setImage] = React.useState(null);
  const [images, setImages] = React.useState([]);
  const [loading, setLoading] = React.useState(true);

  // Fetch patient images
  React.useEffect(() => {
    const fetchImages = async () => {
      if (!patientId) {
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        const response = await axios.get(
          `${BaseUrl}/doctor/medical-documents/${patientId}`,
          {
            withCredentials: true,
          }
        );

        if (response.data?.data && Array.isArray(response.data.data)) {
          setImages(response.data.data);
        } else if (Array.isArray(response.data)) {
          setImages(response.data);
        } else {
          setImages([]);
        }
      } catch (error) {
        console.error("Error fetching images:", error);
        setImages([]);
      } finally {
        setLoading(false);
      }
    };

    fetchImages();
  }, [patientId]);

  // Use placeholder images if no real images
  const displayImages = images.length > 0 ? images : [1, 2, 3, 4, 5, 6].map((i) => ({
    url: `https://placehold.it/300x300?text=Image+${i}`,
    id: i
  }));

  if (loading) {
    return (
      <div className='flex items-center justify-center py-10'>
        <p className='text-textGray'>Loading images...</p>
      </div>
    );
  }

  return (
    <div className='flex-colo gap-8'>
      <div className='grid w-full grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3'>
        {displayImages.map((img, i) => (
            <div key={img.id || i} className='relative w-full'>
              <img
                src={typeof img === 'string' ? img : img.url || img.attachmentUrl || `https://placehold.it/300x300?text=Image+${i + 1}`}
                alt={`patient image ${i + 1}`}
                className='h-72 w-full rounded-lg object-cover'
                onError={(e) => {
                  e.target.src = `https://placehold.it/300x300?text=Image+${i + 1}`;
                }}
              />
              <button
                onClick={() => toast.error("This feature is not available yet.")}
                className='flex-colo absolute -right-1 -top-1 h-8 w-8 rounded-full bg-white'
              >
                <FaTimes className='text-red-500' />
              </button>
            </div>
          ))}
        </div>
    
      <Uploader setImage={setImage} />
      <Button
        onClick={() => toast.error("This feature is not available yet.")}
        label='Save Changes'
        Icon={null}
      />
    </div>
  );
}

export default PatientImages;
